export default "__VITE_ASSET__OOzGV9Lu__"